import { render, staticRenderFns } from "./cooperation.vue?vue&type=template&id=aae1a3e4&scoped=true"
import script from "./cooperation.vue?vue&type=script&lang=js"
export * from "./cooperation.vue?vue&type=script&lang=js"
import style0 from "./cooperation.vue?vue&type=style&index=0&id=aae1a3e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae1a3e4",
  null
  
)

export default component.exports